import script from "./OidoHelpIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./OidoHelpIcon.vue?vue&type=script&setup=true&lang=js"

import "./OidoHelpIcon.vue?vue&type=style&index=0&id=69d13975&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69d13975"]])

export default __exports__